(function () {
  if (!window.location.pathname.includes('/products/')) return;

  /* ── PREV / NEXT NAVIGATION ── */
  function injectProductNav() {
    if (document.querySelector('.canvia-product-nav')) return;

    var collectionHandle = null;
    var pathMatch = window.location.pathname.match(/\/collections\/([^/]+)\/products\//);
    if (pathMatch) {
      collectionHandle = pathMatch[1];
    } else {
      var refMatch = (document.referrer || '').match(/\/collections\/([^/?#]+)/);
      if (refMatch) collectionHandle = refMatch[1];
    }
    if (!collectionHandle) return;

    var productHandle = window.location.pathname.split('/products/')[1];
    if (!productHandle) return;
    productHandle = productHandle.split('?')[0].split('/')[0];

    fetch('/collections/' + collectionHandle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        var idx = -1;
        for (var i = 0; i < products.length; i++) {
          if (products[i].handle === productHandle) { idx = i; break; }
        }
        if (idx === -1) return;

        var prev = idx > 0 ? products[idx - 1] : null;
        var next = idx < products.length - 1 ? products[idx + 1] : null;
        if (!prev && !next) return;

        function truncate(s, n) { return s.length > n ? s.substring(0, n) + '…' : s; }
        function chevron(dir) {
          var pts = dir === 'left' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
          return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + pts + '"></polyline></svg>';
        }
        var linkStyle = 'display:inline-flex;align-items:center;gap:0.5rem;text-decoration:none;color:#222;font-size:0.87rem;padding:0.5rem 0.9rem;border:1px solid #ddd;border-radius:6px;background:#fff;';

        var prevHTML = prev
          ? '<a href="/collections/' + collectionHandle + '/products/' + prev.handle + '" style="' + linkStyle + '">' + chevron('left') + '<span><span style="display:block;font-size:0.73rem;color:#888;margin-bottom:0.1rem">Previous</span><strong>' + truncate(prev.title, 30) + '</strong></span></a>'
          : '';
        var nextHTML = next
          ? '<a href="/collections/' + collectionHandle + '/products/' + next.handle + '" style="' + linkStyle + 'flex-direction:row-reverse;">' + chevron('right') + '<span style="text-align:right"><span style="display:block;font-size:0.73rem;color:#888;margin-bottom:0.1rem">Next</span><strong>' + truncate(next.title, 30) + '</strong></span></a>'
          : '';

        var nav = document.createElement('div');
        nav.className = 'canvia-product-nav';
        nav.setAttribute('style', 'display:flex;justify-content:space-between;align-items:center;max-width:900px;margin:2rem auto;padding:1.5rem 1.5rem 0;border-top:1px solid #eee;gap:1rem;');
        nav.innerHTML =
          '<div style="flex:1;text-align:left">' + prevHTML + '</div>' +
          '<span style="font-size:0.78rem;color:#aaa;white-space:nowrap">' + (idx + 1) + ' / ' + products.length + '</span>' +
          '<div style="flex:1;text-align:right">' + nextHTML + '</div>';

        var main = document.getElementById('MainContent');
        if (main) main.appendChild(nav);
      })
      .catch(function () {});
  }

  /* ── JUDGE.ME STARS → SCROLL TO REVIEWS ── */
  function findReviewSection() {
    var byId = document.getElementById('judgeme_product_reviews');
    if (byId) return byId;
    var all = document.querySelectorAll('.jdgm-widget');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].classList.contains('jdgm-preview-badge')) return all[i];
    }
    return (
      document.querySelector('.jdgm-review-widget') ||
      document.querySelector('[data-jdgm-widget]') ||
      document.querySelector('#jdgm-widget')
    );
  }

  function scrollToEl(el) {
    var rect = el.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.scrollTo({ top: rect.top + scrollTop - 80, behavior: 'smooth' });
  }

  function setupJdgmScroll() {
    var badge = document.querySelector('.jdgm-preview-badge');
    if (!badge || badge.dataset.cvScrollReady) return;
    badge.dataset.cvScrollReady = '1';
    badge.style.cursor = 'pointer';
    badge.addEventListener('click', function (e) {
      var target = findReviewSection();
      if (target) {
        e.preventDefault();
        scrollToEl(target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectProductNav();
      setupJdgmScroll();
    });
  } else {
    injectProductNav();
    setupJdgmScroll();
  }

  // Retry for async Judge.me load
  [400, 1200, 2500].forEach(function (d) { setTimeout(setupJdgmScroll, d); });

  // MutationObserver catches badge appearing after page paint
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      setupJdgmScroll();
      if (document.querySelector('.jdgm-preview-badge[data-cv-scroll-ready]')) {
        mo.disconnect();
      }
    });
    var startObs = function () {
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
    };
    if (document.body) { startObs(); }
    else { document.addEventListener('DOMContentLoaded', startObs); }
  }
})();

// Quick-add AJAX handler — fires before card link, adds to cart via Shopify Cart API
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.canvia-quick-add button[type="submit"]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var form = btn.closest('form');
  if (!form) return;
  var variantId = form.querySelector('input[name="id"]').value;
  if (!variantId) return;
  var orig = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = 'Adding...';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({id: parseInt(variantId), quantity: 1})
  }).then(function(r){return r.json();}).then(function(){
    btn.innerHTML = '&#10003; Added!';
    btn.style.background = '#1a5c35';
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
    setTimeout(function(){btn.innerHTML=orig;btn.style.background='#2c6e49';btn.disabled=false;},1800);
  }).catch(function(){
    btn.innerHTML = 'Error';
    setTimeout(function(){btn.innerHTML=orig;btn.style.background='#2c6e49';btn.disabled=false;},2000);
  });
}, true);
